export default "__VITE_ASSET__DjKJrxI0__"